import LowerBack from "./lower-back/_index";

export default [LowerBack];
